<script lang="ts">
	import { Container, Modal, Text, Button, IconButton, Select } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { roomsScenesFilter, getSelectedSceneFilterCount } from 'src/stores/ui/filters';
	import type { ScenesFilters } from 'src/stores/ui/filters';
	import { capFirstChar, deepCopy } from 'src/helpers/utilities';
	import { defaultSelectedRoom } from 'src/helpers/constants';
	import { rooms } from 'src/stores/lists/rooms';
	import { sortBy } from 'src/components/Lists/list-helpers';

	export let openFilterModal;

	let appliedFilters: ScenesFilters = deepCopy($roomsScenesFilter);

	$: orderedRooms = Object.values($rooms)
		.sort((x, y) => {
			return sortBy(x, y, 'position');
		})
		.map((room: any) => {
			return {
				title: room.name,
				value: room.id,
			};
		});

	$: roomsOptions = [
		{
			...defaultSelectedRoom,
			title: $format(defaultSelectedRoom.title, {
				default: defaultSelectedRoom.translationDefault,
			}),
		},
		{
			value: -1,
			title: 'Global',
		},
		...(orderedRooms && [...orderedRooms]),
	];

	// Find the selected room value from appliedFilters
	$: selectedRoomValue =
		appliedFilters.rooms.find((filter) => filter.value)?.value || defaultSelectedRoom.value;

	// Match it with the translated option from roomsOptions
	$: selectedRoom =
		roomsOptions.find((option) => option.value === selectedRoomValue) || roomsOptions[0];

	const handleFilter = () => {
		roomsScenesFilter.set(appliedFilters);
		openFilterModal = false;
	};

	$: notification = getSelectedSceneFilterCount(appliedFilters);

	function resetData() {
		appliedFilters = {
			rooms: [defaultSelectedRoom],
		};
		notification = getSelectedSceneFilterCount(appliedFilters);
	}

	function handleRoomChange(e) {
		appliedFilters.rooms = [e.detail];
	}
</script>

<Modal
	title={$format('modal_apply_scenes_filters', {
		default: 'Filters',
	})}
	showModal={openFilterModal}
	on:close={() => {
		openFilterModal = false;
	}}
	backdropClose
	{notification}
	removeScrollPadding
>
	<Container fullHeight slot="content" gap="s" padding="scrollPaddings">
		<Text class="mb-s" element="h2"
			>{$format('text_title_scenes_filter_rooms', {
				default: 'Rooms',
			})}</Text
		>
		<Select
			class="width-sm-full width-md-l"
			id="select-room-filter-scenes"
			aria-labelledby="select-room-filter-scenes"
			value={selectedRoom}
			on:change={handleRoomChange}
			options={roomsOptions}
			icon="fas fa-door-open"
			label={$format('all_rooms', { default: 'All rooms' })}
		/>
	</Container>
	<div slot="footer" class="d-flex flex-direction-column">
		<IconButton
			on:click={resetData}
			icon="fas fa-xmark"
			variant="secondary"
			class="width-full"
			disabled={!notification}
		>
			{$format('button_filter_modal_clear_all', { default: 'Clear all' })}
		</IconButton>
		<div class="d-flex justify-content-end mt-md-l mt-sm-m">
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				responsiveSize={{
					sm: 'm',
				}}
				variant="secondary"
				on:click={() => (openFilterModal = false)}
			>
				{$format('button_cancel', { default: 'Cancel' })}
			</Button>
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
				responsiveSize={{
					sm: 'm',
				}}
				on:click={handleFilter}
			>
				{capFirstChar($format('button_apply', { default: 'Apply' }))}
			</Button>
		</div>
	</div>
</Modal>
